import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconPetrol: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="petrol">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 5.9A2.1 2.1 0 0 0 6.9 8v4a2.1 2.1 0 1 0 4.2 0V8A2.1 2.1 0 0 0 9 5.9ZM8.1 8a.9.9 0 0 1 1.8 0v4a.9.9 0 0 1-1.8 0V8Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6 11.6v6.8H15v1.2H3v-1.2h1.4V6A2.6 2.6 0 0 1 7 3.4h4A2.6 2.6 0 0 1 13.6 6v4.4h.4a2.6 2.6 0 0 1 2.6 2.6v4a1.4 1.4 0 1 0 2.8 0v-5.902A2.6 2.6 0 0 1 16.9 8.5V5.748l-1.324-1.324.848-.848L19.84 6.99a2.6 2.6 0 0 1 .761 1.838V17a2.6 2.6 0 0 1-5.2 0v-4a1.4 1.4 0 0 0-1.4-1.4h-.4ZM5.6 6A1.4 1.4 0 0 1 7 4.6h4A1.4 1.4 0 0 1 12.4 6v12.4H5.6V6Zm13.8 2.828v1.068A1.4 1.4 0 0 1 18.1 8.5V6.948l.89.89a1.4 1.4 0 0 1 .41.99Z"
    />
  </Icon>
);
